module.exports = __webpack_public_path__ + "img/theme9.1a167f40.png";